module.exports = __webpack_public_path__ + "static/img/post_snail.5832ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/post_snail.png
// module id = D6jg
// module chunks = 1 3